import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FeedbackModal from './index';

const FeedbackModalWrapper = () => {
  const [showModal, setShowModal] = useState(false);
  const userData = useSelector((state) => state.authSlice.userData);

  useEffect(() => {
    // Check if userData exists and showSuggestionModal is true
    if (userData && userData.showSuggestionModal === true) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [userData]);

  // The modal will only close after successful feedback submission
  // Users cannot bypass this requirement
  const handleModalClose = () => {
    // Only allow closing if showSuggestionModal is false
    if (userData && userData.showSuggestionModal === false) {
      setShowModal(false);
    }
  };

  return <FeedbackModal open={showModal} onClose={handleModalClose} />;
};

export default FeedbackModalWrapper;
